import { RawMonitoringItem } from './monitoring.types'; // export const availableStateIcons: any = {

export const fakeMonitoringItemName = 'Автомобиль А 123 АА 63';
export const fakeMonitoringItemAddress = 'Самарская область, Тольятти, Новый проезд, 8';

export const fakeDataMonitoringItem: RawMonitoringItem = {
  isIgnition: null,
  isMotion: null,
  driversAttached: false,
  trailersAttached: false,
  connectedStatus: null,
  id: NaN,
  name: fakeMonitoringItemName,
  deviceCanSendCommands: true,
  uniqueId: '',
  iconId: 1,
  objectIconColor: '#9F28B4',
  objectCaptionColor: '#EA2568',
  trackColor: {
    type: 'single',
    arrayColor: [],
    singleColor: 'rgba(37, 234, 243, 1)',
  },
  currentUserAccess: [],
  showOnMap: true,
  lastMessage: null,
};
